/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

const Component = ({ dataBanks, setScoreResult }) => {
  const [conditions, setConditions] = useState({
    question1: false,
    question2: false,
  });
  const [form3Data, setForm3Data] = useState({
    question1: { answer: null, score: 0 },
    question2: { answer: null, score: 0 },
    question3: { answer: null, score: 0 },
    question4: { answer: null, score: 0 },
    question5: { answer: null, score: 0 },
  });

  const updateScore = (fieldName, answer, score) => {
    const scoreTemp = { ...form3Data };

    scoreTemp[fieldName] = { answer, score };
    setForm3Data(scoreTemp);
    let scoreCounter = 0;
    let statusTemp = "NONE";

    Object.values(scoreTemp).forEach((element) => {
      scoreCounter += element.score;
    });
    if (scoreTemp.question1.answer === 2 && scoreTemp.question2.answer === 1) {
      scoreCounter -= scoreTemp.question2.score;
    }
    // If (scoreCounter <= 0) {
    //   StatusTemp = "NONE";
    // } else
    if (scoreCounter < 5) {
      statusTemp = "LOW";
    } else if (scoreCounter >= 5 && scoreCounter <= 7) {
      statusTemp = "MEDIUM";
    } else {
      statusTemp = "HIGH";
    }
    const percent = scoreCounter > 0 ? (scoreCounter / 11) * 100 : 0;

    setScoreResult({ status: statusTemp, percentage: percent });
  };

  const selectQuestion1 = (fieldName, answer, score) => {
    updateScore(fieldName, answer, score);
    const conditionTemps = { ...conditions };

    if (answer === 1) {
      conditionTemps.question2 = true;
    } else if (answer === 2) {
      conditionTemps.question2 = false;
    }
    setConditions(conditionTemps);
  };

  useEffect(() => {
    if (Array.isArray(dataBanks) && dataBanks.length > 0) {
      const conditionTemps = { ...conditions };
      let is_HK_Sing = false;
      let is_Others = false;

      dataBanks.forEach((bank) => {
        if (bank.Country.id === 98 || bank.Country.id === 191) {
          is_HK_Sing = true;
        } else {
          is_Others = true;
        }
      });
      if (is_HK_Sing && is_Others) {
        conditionTemps.question1 = true;
        conditionTemps.question2 = false;
      } else if (is_HK_Sing && !is_Others) {
        conditionTemps.question1 = false;
        conditionTemps.question2 = true;
      } else {
        conditionTemps.question1 = false;
        conditionTemps.question2 = false;
      }
      setConditions(conditionTemps);
    }
  }, [dataBanks]);

  return (
    <>
      {conditions.question1 && (
        <div className="mb-6 lg:mb-10">
          <p className="mb-4 font-medium">
            Where are you going to open your bank account?
          </p>
          {/* <div><Combobox options={people} /></div> */}
          <div className="flex flex-col">
            <button
              onClick={() => selectQuestion1("question1", 1, 0)}
              className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
                form3Data.question1.answer === 1
                  ? " bg-bbc-primary text-white"
                  : ""
              }`}
            >
              Onshore banks i.e. Singapore, Hong Kong
            </button>
            <button
              onClick={() => selectQuestion1("question1", 2, 0)}
              className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
                form3Data.question1.answer === 2
                  ? " bg-bbc-primary text-white"
                  : ""
              }`}
            >
              Offshore banks i.e. Belize, BVI, Mauritius,...
            </button>
          </div>
        </div>
      )}
      {conditions.question2 && (
        <div className="mb-6 lg:mb-10">
          <p className="mb-4 font-medium">
            Does your applying company have partners located in the same region
            with your chosen bank?
          </p>
          <div className="flex flex-col">
            <button
              onClick={() => updateScore("question2", 1, 2)}
              className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
                form3Data.question2.answer === 1
                  ? " bg-bbc-primary text-white"
                  : ""
              }`}
            >
              Yes
            </button>
            <button
              onClick={() => updateScore("question2", 2, 0)}
              className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
                form3Data.question2.answer === 2
                  ? " bg-bbc-primary text-white"
                  : ""
              }`}
            >
              No
            </button>
          </div>
        </div>
      )}
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          1. How long have your applying company been in the business?
        </p>
        {/* <div><Combobox options={people} /></div> */}
        <div className="flex flex-col">
          <button
            onClick={() => updateScore("question3", 1, 5)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question3.answer === 1
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            An established bussiness or expansion of an established bussiness
          </button>
          <button
            onClick={() => updateScore("question3", 2, 0)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question3.answer === 2
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            A total newcomer with a well-defined bussiness plan
          </button>
        </div>
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          2. What types of account does your applying company intend to open?
        </p>
        <div className="flex flex-col">
          <button
            onClick={() => updateScore("question4", 1, 2)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question4.answer === 1
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            Trading account
          </button>
          <button
            onClick={() => updateScore("question4", 2, -2)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question4.answer === 2
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            Holding account
          </button>
        </div>
      </div>
      <div className="mb-6 lg:mb-10">
        <p className="mb-4 font-medium">
          3. Does your applying company perform book keeping and annual
          auditing?
        </p>
        <div className="grid grid-cols-2 gap-x-5">
          <button
            onClick={() => updateScore("question5", 1, 2)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question5.answer === 1
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            Yes
          </button>
          <button
            onClick={() => updateScore("question5", 2, -2)}
            className={`mb-4 border-[0.5px] border-bbc-neutral-600 py-2 leading-6 ${
              form3Data.question5.answer === 2
                ? " bg-bbc-primary text-white"
                : ""
            }`}
          >
            No
          </button>
        </div>
      </div>
    </>
  );
};

export default Component;
